/* eslint-disable comma-dangle */

export default {
    address: [
    'user-input',
    'jk',
        'map',
        'highway',
        'underground'
    ],
    'about-object': [
        'common/cadastral-number',
        'common/tax-number',
        'placement-type',
        'commercial-multi-area',
        'can-parts',
        'commercial-area-from',
        'floor-commercial',
        'ceiling-height',
        'has-shop-windows',
        'is-legal-address-provided',
        'common/water-pipes',
        'electricity-power',
        'is-occupied',
        'available-from',
        'specialty',
        {
          name: 'visual-divider',
          hideOnMobile: true,
        },
        'condition-type',
        'has-furniture',
        'common/input-type',
    ],
    'about-building': [
        'name-and-year-commercial',
        'building-type',
        'house-line-type',
        'shopping-center-scale-type',
        'commercial-class',
        'total-area',
        'land',
        {
          name: 'visual-divider',
          hideOnMobile: true,
        },
        'building-status-type',
        'building-developer',
        'building-management-company',
        'additional-items',
        'lift-types',
        {
          name: 'visual-divider',
          hideOnMobile: true,
        },
        'working-days-and-time',
        'tenants'
    ],
    'price-and-deal-terms': [
        'price-multi-sale',
        'vat-type',
        'lease-assignment-checkbox',
        'agent-bonus'
    ]
};
